import { z } from "zod";

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
export const QualidadeItemProcessosFatorSchema = z.object({
    IdItemProcessoFator: optionalNumber,
    IdItemProcesso: optionalNumber,
    FatorRisco: optionalString,
    IternoExterno: optionalString,
    Consequencia: optionalString,
    Oportunidade: optionalString,
    Acao: optionalString,
    Acompanhamento: optionalString,
    Ocorrencia: optionalNumber,
    Impacto: optionalNumber,
    RiscoOportunidade: optionalNumber,
    Delete: z.boolean().optional().default(false),
})

export type QualidadeItemProcessosFatorForm = z.infer<typeof QualidadeItemProcessosFatorSchema>;